import Index from "../../../Index";
import './comingSoon.css'

const ComingSoon = () => {
  return(
  <>
  <Index.Box className="comming-soon-main">
    <Index.Box className="comming-soon-content-main">
        {/* <Index.Typography className="comming-soon-text">Coming soon</Index.Typography> */}
    </Index.Box>
  </Index.Box>
  </>);
};

export default ComingSoon;
